import { Loader2 } from "lucide-react";
import ArbCard from "./ArbCard";

export default function ArbResults({ data, loading, sport }) {
  if (loading) {
    return (
      <div className="flex items-center gap-2 text-zinc-400 mono text-sm">
        <Loader2 size={16} className="animate-spin text-[#00D4FF]" /> Scanning US books…
      </div>
    );
  }
  if (!data || data.count === 0) {
    return (
      <div className="border border-dashed border-zinc-800 p-12 text-center">
        <div className="font-display text-2xl text-zinc-300 mb-2">
          No arbs on {sport.toUpperCase()} right now
        </div>
        <p className="text-sm text-zinc-500">
          Market is efficient on this slate — check another sport or refresh in a few
          minutes.
        </p>
      </div>
    );
  }
  return (
    <div className="space-y-6" data-testid="arb-results">
      {data.arbitrages.map((arb) => (
        <ArbCard key={arb.event_id} arb={arb} />
      ))}
    </div>
  );
}
